import { useQuery } from '@tanstack/react-query';
import type { WorkspaceListItem } from '@deckspace/types';
import { useAuth } from '@deckspace/client';
import type { ApiClient } from '@deckspace/client';
import { queryKeys } from '../lib/queryKeys';

/**
 * Hook to fetch the current user's workspaces via API client.
 * Returns workspace data for sidebar navigation.
 */
export function useWorkspaces(api: ApiClient) {
  const { user } = useAuth();

  const {
    data: workspaces = [],
    isPending,
    error,
  } = useQuery({
    queryKey: queryKeys.workspaces.list(),
    queryFn: (): Promise<WorkspaceListItem[]> => api.listWorkspacesWithSummary(),
    enabled: !!user,
    refetchInterval: 10_000,
  });

  return { workspaces, isPending, error: error as Error | null };
}
